import { gql } from 'react-apollo';

export default gql`
  mutation investorKycRequest($input: InvestorKycRequestInput!) {
    investorKycRequest(input: $input) {
      _id
      kycStatus
      appId
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/investorKycRequest.js